<template>
  <vs-row>
    <h6 class="mt-4 mb-2 px-3">{{ isEdit ? "Editing" : "Inserting" }} Promoted App for {{ app.title + " " + `(${app.language})` }}</h6>
    <vs-row>
      <vs-col vs-lg="6" vs-xs="6">
        <vs-select :color="colorx" label="Language Filter" v-model="language">
          <vs-select-item value text="Select Language" disabled />
          <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" />
        </vs-select>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="6">
        <vs-select :color="colorx" label="Choose App To Promote" v-model="appToPromote">
          <vs-select-item value text="Select App" disabled />
          <vs-select-item :key="index" :value="item.guid" :text="item.title" v-for="(item, index) in apps" />
        </vs-select>
      </vs-col>
    </vs-row>
    <vs-col vs-lg="12" vs-xs="12" class="mt-3">
      <vs-input label="Display Title" v-model="displayTitle" />
    </vs-col>
    <vs-col vs-lg="12" vs-xs="12">
      <vs-input label="Display Description" v-model="displayDescription" />
    </vs-col>
    <vs-col vs-lg="6" vs-xs="6">
      <vs-input type="number" label="Menu Position" v-model="promote.menuPos" :min="1" />
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12" class="mt-4">
      <vs-checkbox v-model="promote.isMenu">Menu (True / False)</vs-checkbox>
    </vs-col>
    <vs-col vs-lg="6" vs-xs="6">
      <vs-input type="number" label="Exit Position" v-model="promote.exitPos" :min="1" />
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12" class="mt-4">
      <vs-checkbox v-model="promote.isExit">Exit (True / False)</vs-checkbox>
    </vs-col>
    <vs-col vs-lg="6" vs-xs="6">
      <vs-input type="number" label="Popup Position" v-model="promote.popupPos" :min="1" />
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12" class="mt-4">
      <vs-checkbox v-model="promote.isPopup">Popup (True / False)</vs-checkbox>
    </vs-col>
    <vs-col vs-lg="6" vs-xs="6">
      <vs-input type="number" label="More Games Position" v-model="promote.moreGamesPos" :min="1" />
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12" class="mt-4">
      <vs-checkbox v-model="promote.isMoreGames">More Games (True / False)</vs-checkbox>
    </vs-col>
    <vs-col vs-lg="12" vs-xs="12" class="mt-3">
      <vs-button icon="save" type="filled" color="primary" @click="saveApp">Save</vs-button>
    </vs-col>
  </vs-row>
</template>
<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import { min } from "moment";
export default {
  name: "InsertPromote",
  props: {
    languageSeleect: {
      type: String,
    },
    itemToPromote: {
      type: Object,
    },
    editObject: {
      type: Object,
    },
  },
  data() {
    return {
      language: "",
      colorx: "#0D2144",
      app: this.itemToPromote,
      appToPromote: "",
      promote: {},
      languages: [],
      apps: [],
      displayTitle: "",
      displayDescription: "",
      isEdit: false,
    };
  },
  watch: {
    async language(newVal) {
      await this.fetchAllApps(newVal);
    },
    appToPromote(newVal) {
      let res = this.$data.apps.filter((obj) => {
        return obj.guid == newVal;
      });
      if (res.length > 0) {
        this.$data.displayTitle = res[0].title;
        this.$data.displayDescription = res[0].description;
      }
    },
  },
  methods: {
    validation() {
      if (this.displayTitle == "" || this.displayTitle == undefined) {
        this.$vs.notify({
          title: "Error",
          text: "Display Title can't be Empty",
          color: "danger",
          position: "top-right",
        });
      } else if (this.displayDescription == "" || this.displayDescription == undefined) {
        this.$vs.notify({
          title: "Error",
          text: "Description Can't be Empty",
          color: "danger",
          position: "top-right",
        });
      } else if (this.promote.appToPromote == "" || this.promote.appToPromote == undefined) {
        this.$vs.notify({
          title: "Error",
          text: "Please Choose the Application to Promote",
          color: "danger",
          position: "top-right",
        });
      } else {
        return true;
      }
    },

    async fetchAllApps(lang) {
      this.$vs.loading();

      try {
        let res = await api.get(`${API.GET_APP}?language=${lang}`, {});
        if (res.status == 200) {
          res.data.filter((obj) => obj.guid === this.itemToPromote.guid);
          this.$data.apps = res.data;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Something went wrong",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    saveApp() {
      if (
        this.$data.promote.menuPos <= 0 ||
        this.$data.promote.exitPos <= 0 ||
        this.$data.promote.popupPos <= 0 ||
        this.$data.promote.moreGamesPos <= 0
      ) {
        this.$vs.notify({
          title: "Error",
          text: "Position for no Input Fields can be Less than 0 or Negative",
          color: "danger",
          position: "top-right",
        });
      } else {
        let res = this.$data.apps.filter((obj) => {
          return obj.guid == this.$data.appToPromote;
        });
        this.$data.promote.appKey = this.$data.app.guid;
        this.$data.promote.appToPromote = this.$data.appToPromote;
        if (this.$data.promote.appToPromote == this.$data.promote.appKey) {
          this.$vs.notify({
            title: "Error",
            text: "App & App To Promote Can't be Same",
            color: "danger",
            position: "top-right",
          });
        } else {
          if (this.validation()) {
            this.$data.promote.appToPromoteObject = res[0];
            this.$data.promote.appToPromoteObject.title = this.$data.displayTitle;
            this.$data.promote.appToPromoteObject.description = this.$data.displayDescription;

            this.$vs.loading();

            let API_TO_CALL = API.INSERT_PROMOTE_APP;
            if (this.$data.isEdit) {
              API_TO_CALL = API.UPDATE_PROMOTE_APP;

              api
                .put(`${API_TO_CALL}/${this.$data.promote._id}`, this.$data.promote)
                .then((r) => {
                  this.$vs.loading.close();
                  if (!r.status == 200) {
                    this.$vs.notify({
                      title: "Error",
                      text: r.data.error,
                      color: "danger",
                      position: "top-right",
                    });
                  } else {
                    this.$vs.notify({
                      title: "Success",
                      text: "Saved Successfully",
                      color: "success",
                      position: "top-right",
                    });
                    this.$data.promote = {};
                    this.$data.language = "";
                    this.$data.displayTitle = "";
                    this.$data.displayDescription = "";
                    this.$data.appToPromote = "";
                    this.$data.appToPromoteObject = {};
                    this.$emit("promoted-object", null);
                    this.$emit("editObject", null);
                    this.$data.isEdit = false;
                  }
                })
                .catch(() => {
                  this.$vs.loading.close();
                  this.$vs.notify({
                    title: "Error",
                    text: "Something went wrong",
                    color: "danger",
                    position: "top-right",
                  });
                });
            } else {
              api
                .post(API_TO_CALL, this.$data.promote)
                .then((r) => {
                  this.$vs.loading.close();
                  if (!r.status == 200) {
                    this.$vs.notify({
                      title: "Error",
                      text: r.data.error,
                      color: "danger",
                      position: "top-right",
                    });
                  } else {
                    this.$vs.notify({
                      title: "Success",
                      text: "Saved Successfully",
                      color: "success",
                      position: "top-right",
                    });
                    this.$data.promote = {};
                    this.$data.language = "";
                    this.$data.displayTitle = "";
                    this.$data.displayDescription = "";
                    this.$data.appToPromote = "";
                    this.$data.appToPromoteObject = {};
                    this.$emit("promoted-object", null);
                    this.$emit("editObject", null);
                    this.$data.isEdit = false;
                  }
                })
                .catch(() => {
                  this.$vs.loading.close();
                  this.$vs.notify({
                    title: "Error",
                    text: "Something went wrong",
                    color: "danger",
                    position: "top-right",
                  });
                });
            }
          }
        }
      }
    },

    async fetchAllLanguages() {
      this.$vs.loading();
      try {
        const r = await api.get(API.GET_LANG, {});
        this.languages = r.data;
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching languages",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },

  async mounted() {
    await this.fetchAllLanguages();

    if (this.editObject == null || this.editObject.appKey == undefined) {
      this.$data.isEdit = false;
      this.$data.language = this.itemToPromote.language;
      await this.fetchAllApps(this.$data.language);
    } else {
      this.$data.isEdit = true;
      this.$data.language = this.editObject.appToPromoteObject.language;
      this.$data.appToPromote = this.editObject.appToPromote;
      this.displayTitle = this.editObject.appToPromoteObject.title;
      this.displayDescription = this.editObject.appToPromoteObject.description;
      this.$data.promote = this.editObject;
      this.fetchAllApps(this.$data.language);
    }
  },
};
</script>
<style scoped></style>
